






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import { BATCH_STATUSES_LABEL_MAP } from '@/constants'
import { EBatchStatus } from '@zunta/configurations'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusBatch extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    switch (this.$props.status) {
      case EBatchStatus.RETURNED_MAIL:
        return EStatusType.error
      case EBatchStatus.INCOMPLETE:
        return EStatusType.attention
      case EBatchStatus.COMPLETE:
        return EStatusType.success
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return BATCH_STATUSES_LABEL_MAP[this.$props.status]
  }
}
